import React from 'react';
import './SplashScreen.css'; // You can style the splash screen using this CSS file

const SplashScreen = () => {
  return (
    <div className="splash-screen">
      <img src="/logo-vertical.jpg" alt="Splash Logo" />
      <h2>Consulting the cosmos...</h2>
    </div>
  );
};

export default SplashScreen;
